import ClientsPage from "./ClientsPage";

export default ClientsPage;
